import React from "react";
import { Loader2 } from "lucide-react";

export const Spinner = ({ className = "" }) => (
  <Loader2 className={`animate-spin ${className}`} />
);

export const PageLoader = () => (
  <div className="flex h-full min-h-[60vh] w-full items-center justify-center">
    <Spinner className="h-8 w-8 text-[var(--brand)]" />
  </div>
);

export const PageHeader = ({ title, subtitle, actions }) => (
  <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
    <div>
      <h1 className="text-2xl font-bold tracking-tight text-slate-900 lg:text-3xl">{title}</h1>
      {subtitle ? <p className="mt-1 text-sm text-slate-500">{subtitle}</p> : null}
    </div>
    {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
  </div>
);

export const StatCard = ({ icon: Icon, value, label, color = "#2563EB" }) => (
  <div className="flex items-center gap-4 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm transition-shadow hover:shadow-md">
    <div className="flex h-12 w-12 items-center justify-center rounded-xl" style={{ backgroundColor: `${color}15` }}>
      {Icon ? <Icon className="h-6 w-6" style={{ color }} /> : null}
    </div>
    <div>
      <div className="text-2xl font-bold text-slate-900">{value}</div>
      <div className="text-xs font-medium uppercase tracking-wide text-slate-500">{label}</div>
    </div>
  </div>
);

export const EmptyState = ({ icon: Icon, title, subtitle, action }) => (
  <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-slate-200 bg-white/50 px-6 py-16 text-center">
    {Icon ? <Icon className="h-12 w-12 text-slate-300" /> : null}
    <p className="mt-4 text-base font-semibold text-slate-600">{title}</p>
    {subtitle ? <p className="mt-1 text-sm text-slate-400">{subtitle}</p> : null}
    {action ? <div className="mt-5">{action}</div> : null}
  </div>
);

export const ErrorBanner = ({ message, testID }) =>
  message ? (
    <div data-testid={testID} className="mb-4 flex items-center gap-2 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-600">
      <span className="font-medium">{message}</span>
    </div>
  ) : null;

export const CategoryBadge = ({ label, color }) => (
  <span className="inline-flex items-center rounded-lg px-2.5 py-1 text-xs font-semibold uppercase tracking-wide" style={{ backgroundColor: `${color}15`, color }}>
    {label}
  </span>
);

export const Card = ({ children, className = "" }) => (
  <div className={`rounded-2xl border border-slate-200 bg-white p-6 shadow-sm ${className}`}>{children}</div>
);

export const SectionTitle = ({ icon: Icon, children, color = "#2563EB", right }) => (
  <div className="mb-4 flex items-center gap-2">
    {Icon ? <Icon className="h-5 w-5" style={{ color }} /> : null}
    <h3 className="flex-1 text-base font-semibold text-slate-900">{children}</h3>
    {right}
  </div>
);
